export const FIELD_ITEM_OUTER_SPACING = '16px';
